import React, { useEffect, useState } from 'react';

import { Button, InputNumber } from '@bringg/react-components';
import { observer } from 'mobx-react-lite';

import TooltipUnassignButton from '../tooltip-unassign-button/tooltip-unassign-button';
import type { TaskTooltipTranslations } from '../../../components/routes-planner/translations';
import type { RouteProps } from '../../../components/routes-select/routes-select';
import RoutesSelect from '../../../components/routes-select/routes-select';

import './task-tooltip-actions.scss';
export interface ResequenceValues {
	priority: number | null;
	runId: number | null;
}
interface Props {
	routesList: RouteProps[];
	tooltipTranslations: TaskTooltipTranslations;
	resequenceValues: ResequenceValues;
	color: string;
	onUnassignClick?: () => void;
	onResequenceChange: (priority: number, routeId: number) => void;
}

const TaskTooltipActions = (props: Props) => {
	const { routesList, tooltipTranslations, resequenceValues, color, onUnassignClick, onResequenceChange } = props;

	const { resequenceTransltions } = tooltipTranslations;

	const [priority, setPriority] = useState<number | null>(null);
	const [selectedRouteId, setSelectedRouteId] = useState<number | null>(null);

	const [isApplyEnabled, setIsApplyEnabled] = useState<boolean>(false);

	useEffect(() => {
		setIsApplyEnabled(
			selectedRouteId !== null &&
				(selectedRouteId !== resequenceValues?.runId || resequenceValues?.priority !== priority)
		);
	}, [priority, selectedRouteId]);

	useEffect(() => {
		setPriority(resequenceValues.priority);
		setSelectedRouteId(resequenceValues.runId);
	}, [resequenceValues]);

	const onApplyForm = () => {
		onResequenceChange(priority, selectedRouteId);
	};

	const getButtonColor = () => {
		const selectedRoute = routesList.find(route => route.id === selectedRouteId);
		return selectedRoute?.color;
	};

	const onSetPriority = priority => {
		setPriority(priority);
	};

	return (
		<>
			<div className="resequence-task">
				<div className="inputs-container">
					<div>
						<div className="input-title">{resequenceTransltions.priority}</div>
						<InputNumber
							value={priority}
							min={1}
							onChange={onSetPriority}
							className="input-number"
							data-test-id="resequence-priority-input"
						/>
					</div>
					<div className="route-input-container">
						<div className="input-title">{resequenceTransltions.route}</div>
						<RoutesSelect
							routes={routesList}
							selectedValue={selectedRouteId}
							onSelect={setSelectedRouteId}
						/>
					</div>
				</div>
				<div className="buttons-container">
					{resequenceValues.runId !== null && onUnassignClick && (
						<TooltipUnassignButton
							color={color}
							text={tooltipTranslations.unassign}
							onClick={onUnassignClick}
						/>
					)}
					<Button
						className="apply-button task-tooltip-apply-button"
						disabled={!isApplyEnabled}
						onClick={onApplyForm}
						value={priority}
						type="primary"
						style={{ '--color': getButtonColor() } as React.CSSProperties}
						data-test-id="resequence-apply-button"
					>
						{resequenceTransltions.apply}
					</Button>
				</div>
			</div>
		</>
	);
};

export default observer(TaskTooltipActions);
